import { Component, OnInit } from '@angular/core';
import { StorageService } from './../../../core/service/storage.service';

@Component({
  selector: 'app-cookie-info',
  templateUrl: './cookie-info.component.html',
  styleUrls: ['./cookie-info.component.scss'],
  standalone: false,
})
export class CookieInfoComponent implements OnInit {
  constructor(private localStorage: StorageService) {}

  show: boolean;

  ngOnInit() {
    this.show = !(<any>this.localStorage.getValue('cookies-hide-information')) as boolean;
  }

  ok() {
    this.show = false;
    this.localStorage.set('cookies-hide-information', true);
  }
}
